// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider-root-25Hfx","spacing1":"Divider-spacing1-2_fV6","spacing2":"Divider-spacing2-fAIA_","spacing3":"Divider-spacing3-Aqvi1","spacing4":"Divider-spacing4-1t3wQ"};